import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { BlogOverview } from "@/components/calv/blog/BlogOverview";
import { listPosts } from "@/lib/blog";

export const Route = createFileRoute("/en/blog/")({
  loader: () => listPosts("en"),
  head: () => {
    const h = pageHead("blog", "en");
    return { meta: h.meta, links: h.links };
  },
  component: BlogIndex,
});

function BlogIndex() {
  const posts = Route.useLoaderData();
  return <BlogOverview locale="en" posts={posts} />;
}
